export default "__VITE_ASSET__CgjZA7OP__"